import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class EventEmitterService {

  private brokerChangeSource = new Subject<any>();
  brokerChangeEmitted$ = this.brokerChangeSource.asObservable();

  brokerChange(change: any) {
      this.brokerChangeSource.next(change);
  }

  // Changing properties in child tour component
  private propertyChangeSource = new Subject<any>();
  propertyChangeEmitted$ = this.propertyChangeSource.asObservable();

  propertyChange(change: any) {
      this.propertyChangeSource.next(change);
  }

  // Changing properties in child tour component
  private selfTourStepChangeSource = new Subject<any>();
  selfTourStepChangeEmitted$ = this.selfTourStepChangeSource.asObservable();

  selfTourStepChange(change: any)
  {
    this.selfTourStepChangeSource.next(change)
  }

  // Self tour Modal text change
  private selfTourModalTextChangeSource = new Subject<any>();
  selfTourModalTextChangeEmitted$ = this.selfTourModalTextChangeSource.asObservable();

  selfTourModalTextChange(change: any)
  {
    this.selfTourModalTextChangeSource.next(change)
  }

  // Self tour Modal close change
  private selfTourModalCloseChangeSource = new Subject<any>();
  selfTourModalCloseChangeEmitted$ = this.selfTourModalCloseChangeSource.asObservable();

  selfTourModalCloseChange(change: any)
  {
    this.selfTourModalCloseChangeSource.next(change)
  }

    // Changing renderConfirm in login component
    private renderConfirmChangeSource = new Subject<any>();
    renderConfirmChangeEmitted$ = this.renderConfirmChangeSource.asObservable();
  
    renderConfirm(change: any) {
        this.renderConfirmChangeSource.next(change);
    }

  // Changing splash image in login component
  private splashChangeSource = new Subject<any>();
  splashChangeEmitted$ = this.splashChangeSource.asObservable();

  splashChange(change: any) {
      this.splashChangeSource.next(change);
  }
    
  constructor() { }    
    
}
